import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { CTAButton } from '../ui/CTAButton';
export function HeroSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };
  return <section className="relative min-h-screen flex flex-col items-center justify-center w-full bg-bg bg-grid px-6 pt-20 pb-10 overflow-hidden" data-id="element-60">
      {/* Subtle radial gradient overlay to ensure text readability over the grid */}
      <div className="absolute inset-0 bg-bg/80 bg-[radial-gradient(circle_at_center,transparent_0%,#0a0a0a_100%)] pointer-events-none" data-id="element-61" />

      <motion.div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center" variants={containerVariants} initial="hidden" animate="visible" data-id="element-62">
        <motion.div variants={itemVariants} className="flex items-center gap-3 mb-8" data-id="element-63">
          <div className="w-2 h-2 rounded-full bg-accent glow-green" data-id="element-64" />
          <span className="text-accent font-heading font-semibold tracking-[0.2em] text-sm md:text-base uppercase" data-id="element-65">
            Sistema de Ingeniería Social
          </span>
          <div className="w-8 h-[1px] bg-accent/50 hidden md:block" data-id="element-66" />
        </motion.div>

        <motion.h1 variants={itemVariants} className="font-heading font-black text-3xl sm:text-5xl md:text-7xl lg:text-8xl text-text-primary uppercase tracking-tight leading-[1.1] mb-8" data-id="element-67">
          Arquitectura <br className="hidden md:block" data-id="element-68" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-text-secondary" data-id="element-69">
            Mental de
          </span>{' '}
          <br className="hidden md:block" data-id="element-70" />
          <span className="text-glow text-accent" data-id="element-71">Influencia</span>
        </motion.h1>

        <motion.p variants={itemVariants} className="font-body text-lg md:text-xl text-text-secondary max-w-2xl mx-auto leading-relaxed mb-8" data-id="element-72">
          El sistema de ingeniería social para guiar decisiones, instalar ideas
          y dominar el marco de cualquier conversación.
        </motion.p>

        {/* Product image */}
        <motion.div variants={itemVariants} className="mb-10" data-id="element-73">
          <img src="https://cdn.magicpatterns.com/uploads/eZ4Nq5vkPKXydpYXUmX29m/heylloyd-image-1772481907061.png" alt="Arquitectura Mental de Influencia" className="w-52 sm:w-64 md:w-72 h-auto mx-auto rounded-lg shadow-[0_0_50px_rgba(0,255,136,0.15)]" data-id="element-74" />
        </motion.div>

        <motion.div variants={itemVariants} data-id="element-75">
          <CTAButton onClick={() => document.getElementById('price-block')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-76">
            Quiero el acceso
          </CTAButton>
        </motion.div>
      </motion.div>

      <motion.div className="absolute bottom-10 left-1/2 -translate-x-1/2 text-text-secondary/50" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} data-id="element-77">
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} data-id="element-78">
          <ChevronDown className="w-8 h-8" data-id="element-79" />
        </motion.div>
      </motion.div>
    </section>;
}